import { render } from "./SpinnerIcon.vue?vue&type=template&id=00233ea3&scoped=true"
import script from "./SpinnerIcon.vue?vue&type=script&lang=js"
export * from "./SpinnerIcon.vue?vue&type=script&lang=js"

import "./SpinnerIcon.vue?vue&type=style&index=0&id=00233ea3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00233ea3"]])

export default __exports__